<input
  class="d-none qa-file-upload-input"
  type="file"
  #fileInput
  (change)="onFilesAdded($any($event?.target)?.files)"
  [multiple]="isMultiple"
  [accept]="accept"
/>

<ng-container
  *ngTemplateOutlet="uploadButtonTemplate ? uploadButtonTemplate: defaultUploadButton; context: publicContext"
></ng-container>
<ng-template #defaultUploadButton>
  <button
    (click)="onAddFiles()"
    mat-flat-button
    color="primary"
    class="fileUpload_button qa-file-upload-btn"
    data-testId="file-upload"
  >
    <mat-icon svgIcon="cloud-upload"></mat-icon>
    <span class="mt-n2">Add files</span>
  </button>
</ng-template>
